export const formatPhone = (value) => {
  const numbers = value.replace(/\D/g, "");

  if (numbers.length > 10) {
    // Celular: (99) 99999-9999
    return numbers
      .replace(/^(\d{2})(\d)/, "($1) $2")
      .replace(/(\d{5})(\d)/, "$1-$2")
      .slice(0, 15);
  } else {
    // Fixo: (99) 9999-9999
    return numbers
      .replace(/^(\d{2})(\d)/, "($1) $2")
      .replace(/(\d{4})(\d)/, "$1-$2")
      .slice(0, 14);
  }
};